import { lighten, rgba } from 'polished';

import colours from './colours'

/** Light theme colour variables */
const lightTheme = {
	black: '#000000',
	white: '#ffffff',
	body: colours.porcelain,
	neutral: '#f2f2f2',
	neutralLight: '#fefefe',
	borders: rgba(0, 0, 0, 0.2),
	inputBorder: rgba(0, 0, 0, 0.2),
	text: '#000000',
	textButton: colours.dodgerBlue,
	textLink: colours.cornflowerBlue,
	textLight: '#545454',
	placeholder: rgba('#000000', 0.6),
	bgPrimary: '#FFFFFF',
	selectBackground: '#e9edf3',
	popupBackground: rgba(colours.mineShaft, 0.1),
	announcementBackground: colours.azureRadiance,
	headings: colours.mineShaft,
	primary: '#717CBC',
	secondary: '#5AF091',
	genericError: '#D63636',
	get link() {
		return this.primary;
	},
	get linkHover() {
		return lighten(0.02, this.primary);
	},
	get linkActive() {
		return lighten(0.08, this.primary);
	},
	get validationDisabled() {
		return this.neutral;
	},
	validationError: '#dc3545',
	validationSuccess: '#28a745',
	validationWarning: '#ffc107',
};

export default lightTheme;
